import { type AssignableRole } from '../models/roles';

export const ROLE_NAMES_TO_ASSIGN: AssignableRole[] = [
  'admin',
  'controller',
  'requester',
];
